import React, { Suspense } from 'react';
import type { ReactNode } from 'react';
import PageLayout from './PageLayout';
import RightPanel from './RightPanel';

interface PageProps {
  topbar?: ReactNode;
  children: React.ReactNode;
}

const Page = ({ topbar, children }: PageProps) => {
  return (
    <RightPanel.Provider>
      {topbar}
      <RightPanel.Root />
      <PageLayout.Inner>
        <Suspense fallback={null}>{children}</Suspense>
      </PageLayout.Inner>
    </RightPanel.Provider>
  );
};

export default Page;
